import * as React from 'react';

import * as ModalActions from '../store/actions/modals';

const DownloadSuccessModal = React.lazy(
  () =>
    import(
      /* webpackChunkName: "modal-download-success" */ '../components/modals/DownloadSuccessModal/DownloadSuccessModal'
    ),
);
const LowInventoryModal = React.lazy(
  () =>
    import(/* webpackChunkName: "modal-low-inventory" */ '../components/modals/LowInventoryModal/LowInventoryModal'),
);
const RemovePIIModal = React.lazy(
  () => import(/* webpackChunkName: "modal-remove-pii" */ '../components/modals/RemovePIIModal/RemovePIIModal'),
);

const RocketModal = React.lazy(
  () => import(/* webpackChunkName: "modal-rocket" */ '../components/modals/RocketModal/RocketModal'),
);

export const MODALS = {
  ROCKET: 'rocket',
  DOWNLOAD_SUCCESS: 'download-success',
  LOW_INVENTORY_ITEMS: 'low-inventory-items',
  REMOVE_PII: 'remove-pii',
  MULTIPLE_PORTAL_WARNING: 'multiple-portal-warning',
};

export const MODAL_COMPONENTS = {
  [MODALS.ROCKET]: RocketModal,
  [MODALS.DOWNLOAD_SUCCESS]: DownloadSuccessModal,
  [MODALS.LOW_INVENTORY_ITEMS]: LowInventoryModal,
  [MODALS.REMOVE_PII]: RemovePIIModal,
};

export const MODAL_ACTIONS = {
  [MODALS.ROCKET]: ModalActions.toggleRocketModal,
  [MODALS.DOWNLOAD_SUCCESS]: ModalActions.toggleDownloadSuccessModal,
  [MODALS.LOW_INVENTORY_ITEMS]: ModalActions.toggleLowInventoryModal,
  [MODALS.REMOVE_PII]: ModalActions.toggleRemovePIIModal,
};
